import { Modal } from "best-common-react";
import React from "react";
import { BillingDTO } from "../../types/UserBilling";
import useCyberSource from "../../util/CreditCardUtil";
import NewCreditCardForm from "./NewCreditCardForm";

type NewCreditCardModalProps = {
  show: boolean;
  onClose: (value: BillingDTO | undefined) => void;
  userId?: number;
};

const NewCreditCardModal: React.FC<NewCreditCardModalProps> = ({ show, onClose, userId }) => {
  const { onCancel } = useCyberSource(null, userId);

  React.useEffect(() => {
    onCancel();
  }, [show]);

  return (
    <Modal show={show} size="xl">
      <Modal.Header close={() => onClose(undefined)}>Add a credit card</Modal.Header>
      <Modal.Body>
        {!!userId && (
          <NewCreditCardForm
            show={true}
            onClose={() => onClose(undefined)}
            userId={userId}
            refresh={async (userBilling: BillingDTO) => {
              onClose(userBilling);
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NewCreditCardModal;
